
import './Input.scss'

export default function Input({ onChange, disabled = false, placeholder = '', label, name, value = '', type = 'text', ...props }) {
    var classes = [];
    const id = `input-${name}`;
    if (disabled) {
        classes.push('disabled');
    }

    return (<div className={`Input ${classes}`}>
        <label htmlFor={id}>{label}</label>
        <input
            disabled={disabled}
            onChange={onChange}
            type={type}
            placeholder={placeholder}
            id={id}
            name={name}
            value={value}

            {...props}
        />
    </div>)

}

